<template>
  <div>
    <div class="wg-row no-select com-anm22-food-fc-cat-div-new">
      <div
        v-for="(cat,index) in mainCategories"
        :key="'cat'+index"
        :class="[ 
            'wg-row',
            'com-anm22-food-fc-cat-button', 
            'com-anm22-app-pages', 
            selected === index ? 'com-anm22-app-pages-selected' : ''
          ]"
        style="cursor:pointer;"
        @click="changePage(index)"
      >
        <div
          class="com-anm22-app-text-xxl"
          style="font-weight:bold;"
        >{{ cat.langName.toUpperCase() }}</div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div
      v-if="multiView"
      class="wg-row"
      style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;"
    >
      <img
        :src="$anm22.icons.getWorldIcon('list')"
        class="com-anm22-app-img-fixed-height-l"
        :style="{cursor: 'pointer', opacity: view === 'image' ? '0.3' : '1'}"
        @click="setView('list')"
      >
      <div style="border-right:1px solid #ccc;height:40px;margin:0 10px;"></div>
      <img
        :src="$anm22.icons.getWorldIcon('grid')"
        class="com-anm22-app-img-fixed-height-l"
        :style="{cursor: 'pointer', opacity: view === 'list' ? '0.3' : '1', marginRight: '10px'}"
        @click="setView('image')"
      >
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <template v-for="(cat,index) in mainCategories">
      <div
        :key="'prod-cat-' + cat.id"
        v-show="selected === index"
        class="display-flex com-anm22-food-menu-cat-div-v no-select"
      >
        <div
          v-if="getCategoryProducts(cat, false).length === 0 && getCategoryChildren(cat).length === 0"
        >{{ $anm22.strLang(lang, 'No products in this category', 'Nessun prodotto in questa categoria') }}</div>
        <div class="wg-row" :style="view === 'image' ? {alignItems: 'flex-start'} : {alignItems: 'stretch'}">
          <product
            v-for="(prod) in getCategoryProducts(cat, true)"
            :key="'cat-prod-'+prod.id"
            :view="view"
            :product="prod"
            :onclick="addOrderElement"
            :elements="elements"
          ></product>
        </div>
      </div>
      <div 
          v-for="(subcat) in getCategoryChildren(cat)"
          :key="'prod-cat-'+subcat.id"
          v-show="selected === index"
          class="display-flex com-anm22-food-menu-cat-div-v no-select"
        >
        <div class="com-anm22-food-fc-subcat-label">
          {{ subcat.langName.toUpperCase() }}
        </div>
        <div class="com-anm22-food-fc-cat-empty-label" v-if="getCategoryProducts(subcat, false).length === 0">
          {{ $anm22.strLang(lang, 'No products in this sub-category', 'Nessun prodotto in questa sottocategoria') }}
        </div>
        <div class="wg-row" :style="view === 'image' ? {alignItems: 'flex-start'} : {alignItems: 'stretch'}">
          <product
            v-for="(prod) in getCategoryProducts(subcat, true)"
            :key="'cat-prod-'+prod.id"
            :view="view"
            :product="prod"
            :onclick="addOrderElement"
            :elements="elements"
          ></product>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Product from './Product.vue';

export default {
  props: {
    elements: Array
  },
  components: {
    Product
  },
  data() {
    return {
      view: 'list',
      selected: 0,
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    multiView () {
      return this.license.fastcashMultiview;
    },
    categories() {
      return this.$store.getters['foodCategories/getByLicense'](this.license.id)
          .filter(c => c.langName !== null && !c.deleted && c.visible);
    },
    mainCategories() {
      return this.categories
          .filter(c => !c.parent)
          .sort((a, b) => a.ordering - b.ordering);
    },
    products() {
      return this.$store.getters['foodProducts/getByLicense'](this.license.id)
          .filter(p => p.langName !== null && !p.deleted);
    }
  },
  methods: {
    changePage(index) {
      this.selected = index;
    },
    setView(view) {
      this.$anm22.setCookie('fastcashView', view, 31536000);
      this.view = view;
    },
    getCategoryProducts(cat, sort) {
      const products = [];
      const productsTop = [];
      this.products.forEach(p => {
        if(p.category === cat.id && p.status != 2) {
          if(p.pinToTop) {
            productsTop.push(p);
          } else {
            products.push(p);
          }
        }
      });
      if(sort && this.license.orderByName) {
        const field = 'name' + this.$anm22.capitalizeFirst(this.lang);
        const fn = (a, b) => {
          const aValue = a[field] || a['name'];
          const bValue = b[field] || b['name'];
          return aValue.localeCompare(bValue);
        };
        products.sort(fn);
        productsTop.sort(fn);
      }
      return productsTop.concat(products);
    },
    getCategoryChildren(cat) {
      return this.categories
          .filter(c => c.parent === cat.id)
          .sort((a, b) => b.ordering - a.ordering);
    },
    addOrderElement(product) {
      this.$emit('add-element', product);
    }
  },
  created: function() {
    if(this.$anm22.getCookie("fastcashView") !== ""){
      this.view = this.$anm22.getCookie("fastcashView");
    }
  }
};
</script>

<style lang="scss" scoped>
.com-anm22-food-fc-cat-button {
  text-align: center;
}
</style>
